import React from 'react'
import cx from 'classnames'
import Icon from 'components/Icon'
import styles from './BusinessName.scss'
import { EllipsisCell } from 'uikit/tables/default'

interface BusinessNameProps {
  alignedLeft?: boolean
  business?: {
    nonFiler?: boolean
    underReport?: boolean
    businessName?: string
  }
}

const BusinessName: React.FC<BusinessNameProps> = ({ alignedLeft = false, business = {} }) => (
  <span className={cx(styles.container, { [styles.alignedLeft]: alignedLeft })}>
    <span className={styles.icons}>
      {business.nonFiler && <Icon name='nonFiler' size='small' />}
      {business.underReport && <Icon name='arrowDown' size='small' />}
    </span>
    <span
      className={cx(styles.name, {
        [styles.withIcons]: business.nonFiler || business.underReport,
      })}
    >
      <EllipsisCell>{business.businessName}</EllipsisCell>
    </span>
  </span>
)

export default BusinessName

